import {Component, inject, signal, WritableSignal, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MatOptionModule} from "@angular/material/core"
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog"
import {MatInputModule} from "@angular/material/input"
import {MatSelectModule} from "@angular/material/select"
import {MatMenuModule} from "@angular/material/menu"
import {AddItemDialogComponent} from "@common/components/dialogs/add-item-dialog/add-item-dialog.component"
import {InputContainerComponent} from "@common/components/inputs/input-container/input-container.component"
import {StringInputComponent} from "@common/components/inputs/string-input/string-input.component"
import {EditJobFarmGroupDialogJobFarmGroupFragment} from "@app/platform/components/job-farm-groups/edit-job-farm-group-dialog/edit-job-farm-group-dialog.generated"
import {OrganizationsService} from "@common/services/organizations/organizations.service"
import {JobFarmGroupDialogResult} from "@platform/components/job-farm-groups/job-farm-groups-table/job-farm-groups-table.component"
import {v4 as uuid4} from "uuid"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-edit-job-farm-group-dialog",
    templateUrl: "./edit-job-farm-group-dialog.component.html",
    styleUrl: "./edit-job-farm-group-dialog.component.scss",
    imports: [
        MatInputModule,
        MatDialogModule,
        FormsModule,
        MatOptionModule,
        MatSelectModule,
        MatButtonModule,
        MatMenuModule,
        AddItemDialogComponent,
        InputContainerComponent,
        StringInputComponent,
    ],
})
export class EditJobFarmGroupDialogComponent {
    readonly $result: WritableSignal<JobFarmGroupDialogResult>

    readonly organizations = inject(OrganizationsService)
    readonly dialogRef = inject(MatDialogRef<EditJobFarmGroupDialogComponent>)
    readonly jobFarmGroup = inject<EditJobFarmGroupDialogJobFarmGroupFragment>(MAT_DIALOG_DATA)

    constructor() {
        this.$result = signal<JobFarmGroupDialogResult>({
            id: this.jobFarmGroup.id,
            name: this.jobFarmGroup.name,
            organizationId: this.jobFarmGroup.organization?.id,
            queueGroup: this.jobFarmGroup.queueGroup,
        })
    }

    get isFormValid(): boolean {
        const result = this.$result()
        return !!(result.name && result.organizationId && result.queueGroup)
    }

    readonly title = this.jobFarmGroup.id ? "Edit Group" : "Create Group"

    readonly confirmButtonText = this.jobFarmGroup.id ? "Update" : "Create"

    delete(): void {
        this.$result.update((r) => ({...r, delete: true, create: false}))
        this.dialogRef.close(this.$result())
    }

    updateOrCreate(): void {
        this.$result.update((r) => {
            const isCreate = r.id == null
            return {...r, delete: false, create: isCreate, id: isCreate ? uuid4() : r.id}
        })
        this.dialogRef.close(this.$result())
    }
}
